import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { memo } from "react";

interface LinkDialogProps {
  open: boolean;
  linkText: string;
  linkUrl: string;
  onClose: () => void;
  onChangeLinkText: (text: string) => void;
  onChangeLinkUrl: (url: string) => void;
  onInsert: () => void;
  insertDisabled: boolean;
}
  
const LinkDialog = memo(function LinkDialog({
  open,
  linkText,
  linkUrl,
  onClose,
  onChangeLinkText,
  onChangeLinkUrl,
  onInsert,
  insertDisabled,
}: LinkDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Insert Link</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Text to display"
          fullWidth
          variant="standard"
          value={linkText}
          onChange={(e) => onChangeLinkText(e.target.value)}
        />
        <TextField
          margin="dense"
          label="URL"
          type="url"
          fullWidth
          variant="standard"
          value={linkUrl}
          onChange={(e) => onChangeLinkUrl(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onInsert} disabled={insertDisabled}>
          Insert
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default LinkDialog;